/* ===== Artist Push — cart P1 (09.2026): липка панель checkout (мобайл) + блок рекомендації.
   Самодостатній; логіка checkout, стан кошика і форма живуть у cart-v2.js — тут ми
   лише (а) показуємо панель, коли справжня кнопка за екраном, і сабмітимо ту саму форму
   через requestSubmit(#ap-checkout-btn); (б) підбираємо один товар-рекомендацію за
   драбиною платформа→послуга, побудованою на реальних спільних покупках. ===== */
(function () {
  'use strict';
  var form = document.getElementById('cart');
  if (!form) return;

  /* ---------- самолікування атрибута cross_sell (09.2026) ----------
     Баг: атрибут cross_sell ставився при додаванні товару з віджета і не знімався, якщо
     покупець потім прибирав цей товар з кошика. Правдиве джерело — властивість рядка
     _source: cart-reco; атрибут лише підтягуємо до неї. Логіку видалення товару не
     перехоплюємо, щоб не чіпати cart-v2.js: звіряємо стан при кожному відкритті кошика.
     Нічого не перезавантажуємо (атрибут покупцю не видний), помилки глушимо — кошик
     важливіший за трекінг. */
  (function healCrossSell() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.attributes || !cart.attributes.cross_sell) return null;
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          var pr = items[i].properties;
          /* _anchor приймаємо теж — ширша умова, помиляється в бік «не прибирати» */
          if (pr && (pr._source === 'cart-reco' || pr._anchor)) return null;
        }
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { cross_sell: '' } })
        });
      })
      .catch(function () {});
  })();
  var realBtn = document.getElementById('ap-checkout-btn');
  var link = document.getElementById('ap-cart-link');
  var linkBlock = document.getElementById('ap-link-block');

  /* ---------- липка панель ---------- */
  var panel = document.getElementById('ap-sticky');
  var panelBtn = document.getElementById('ap-sticky-btn');
  var panelTotal = document.getElementById('ap-sticky-total');
  var panelEu = document.getElementById('ap-sticky-eu');
  var mobile = window.matchMedia('(max-width: 989px)');
  var btnVisible = true, linkFocused = false;

  /* Чат-бабл Shopify Inbox (<shopify-chat>, z-index 2147483000, host на весь екран) лежить поверх
     кнопки. Піднімаємо лише кнопку-активатор усередині shadow DOM (не вікно чату): віджет
     позиціонує її через bottom: calc(--shopify-chat-activator-offset + --private-preview-bar-offset),
     ми додаємо до цієї формули свою змінну --ap-lift з host. Transition тут навмисно нема — з ним
     Chrome не перераховує calc() при зміні змінної. Якщо shadow DOM недоступний — нічого не робимо. */
  function liftChat(on) {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return;
    var sr = chat.shadowRoot;
    if (sr && !sr.getElementById('ap-lift-style')) {
      var st = document.createElement('style');
      st.id = 'ap-lift-style';
      st.textContent = '.activator-nudge{bottom:calc(var(--shopify-chat-activator-offset,20px) + var(--private-preview-bar-offset,0px) + var(--ap-lift,0px)) !important}';
      sr.appendChild(st);
    }
    chat.style.setProperty('--ap-lift', on ? (panel.offsetHeight + 8) + 'px' : '0px');
  }
  /* віджет чату вантажиться пізніше за нас — підхоплюємо його, щойно зʼявиться */
  if (window.MutationObserver && !document.querySelector('shopify-chat')) {
    var chatWatch = new MutationObserver(function () {
      if (document.querySelector('shopify-chat')) { chatWatch.disconnect(); liftChat(panel.classList.contains('is-on')); }
    });
    chatWatch.observe(document.documentElement, { childList: true, subtree: true });
  }

  function render() {
    var on = mobile.matches && !btnVisible && !linkFocused;
    panel.classList.toggle('is-on', on);
    panel.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.classList.toggle('ap-sticky-pad', on);
    liftChat(on);
  }
  if ('IntersectionObserver' in window && realBtn) {
    new IntersectionObserver(function (entries) {
      btnVisible = entries[0].isIntersecting;
      render();
    }, { threshold: 0.6 }).observe(realBtn);
  } else { btnVisible = false; render(); }

  form.addEventListener('focusin', function (e) { if (e.target === link) { linkFocused = true; render(); } });
  form.addEventListener('focusout', function (e) { if (e.target === link) { linkFocused = false; setTimeout(render, 150); } });
  window.addEventListener('resize', function () { if (panel.classList.contains('is-on')) liftChat(true); });

  /* total + EU-текст синхронізуються зі справжньою карткою (cart-v2.js переписує #total-value і вмикає EU-варіант) */
  var totalEl = document.getElementById('total-value');
  function syncPanel() {
    if (totalEl) panelTotal.textContent = totalEl.textContent;
    var eu = realBtn && realBtn.classList.contains('ap-checkout-btn--eu');
    if (eu) {
      var euText = document.getElementById('ap-agreement-eu');
      if (euText && !panelEu.innerHTML) panelEu.innerHTML = euText.innerHTML;
      panelEu.hidden = false;
      panelBtn.textContent = realBtn.textContent;
      panelBtn.classList.add('ap-checkout-btn--eu');
    }
    if (panel.classList.contains('is-on')) liftChat(true);
  }
  syncPanel();
  if (window.MutationObserver) {
    if (totalEl) new MutationObserver(syncPanel).observe(totalEl, { childList: true, characterData: true, subtree: true });
    if (realBtn) new MutationObserver(syncPanel).observe(realBtn, { attributes: true, attributeFilter: ['class'] });
  }

  /* 27.10.2026 (Яна): тап по липкій кнопці ЗАВЖДИ веде в checkout, навіть якщо поле
     посилання порожнє. Старий патерн «перший тап — підказка і фокус на полі, другий —
     checkout» збивав з пантелику: фокус на полі ховав панель разом із підказкою, і це
     виглядало як «кнопка не працює». Лінк не обов'язковий, його просять після замовлення. */
  panelBtn.addEventListener('click', function () {
    /* запасний шлях для браузерів без requestSubmit (iOS ≤15): клік по справжній кнопці,
       щоб не загубити name="checkout" і submit-обробники (згода, країна) */
    if (form.requestSubmit && realBtn) form.requestSubmit(realBtn);
    else if (realBtn) realBtn.click();
    else form.submit();
  });
  /* «Назад» з checkout (bfcache) повертає сторінку в тому ж стані — перераховуємо панель */
  window.addEventListener('pageshow', function (e) { if (e.persisted) render(); });

  /* ---------- рекомендація ---------- */
  var reco = document.getElementById('ap-upsell');
  var slot = document.getElementById('ap-reco-slot');
  if (!reco || !slot || reco.hidden) return;
  var inCart = (reco.getAttribute('data-in-cart') || '').split(',');
  var rootEl = document.querySelector('.ap-cart');
  var symbol = (rootEl && rootEl.getAttribute('data-currency-symbol')) || '$';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ===== Логіка рекомендації (v2, 09.2026; узгоджено з Яною) =====
     Платформу визначаємо за ТИПОМ товару (product_type), а не за назвою: у Spotify-товарів
     слова Spotify в назві немає («Buy Plays», «Buy Saves»). Кандидатів беремо з повного
     каталогу /products.json — він віддає і приховані від Google товари (Spotify/SoundCloud),
     на відміну від штатного пошуку Shopify.
     Порядок: 1) своя платформа за правилами SAME → 2) «Popular» своєї платформи →
     3) інша платформа за CROSS → 4) «Popular» тієї платформи → 5) рекомендації Shopify.
     Дані: 6 152 оплачених замовлень з 04.2026 — 77% з однією позицією; друга позиція у 97%
     випадків тієї ж платформи. Крос-пари з даних: Apple↔Spotify, Tidal→Apple, Twitch→YouTube,
     Facebook→Instagram, TikTok→Instagram, Mixcloud→SoundCloud. Beatport/RA/Traxsource — логіка Яни.

     Як редагувати: SAME[платформа] — список правил {when: [слова з назви товару в кошику],
     want: [слова з назви товару, який радимо]}; перше правило, що збіглося, перемагає, слова
     в нижньому регістрі. CROSS[платформа] = [платформа-ціль, слова назви]. */
  var SAME = {
    spotify: [
      { when: ['organic listeners'], want: ['buy saves'] },
      { when: ['monthly listeners', 'algorithmic'], want: ['buy plays'] },
      { when: ['playlist'], want: ['buy plays'] },
      { when: ['mix'], want: ['monthly listeners'] },
      { when: ['plays', 'royalty', 'targeted', 'saves', 'followers', 'listeners'], want: ['monthly listeners'] }
    ],
    soundcloud: [
      { when: ['organic push', 'pack', 'mix', 'package'], want: ['plays usa'] },
      { when: ['plays'], want: ['soundcloud likes'] },
      { when: ['likes', 'reposts', 'followers', 'comments'], want: ['soundcloud plays'] }
    ],
    youtube: [
      { when: ['starter', 'pro:', 'digger', 'star:'], want: ['custom youtube comments'] },
      { when: ['views'], want: ['youtube likes'] },
      { when: ['likes', 'subscribers', 'comments'], want: ['youtube views'] }
    ],
    instagram: [
      { when: ['starter', 'pro:', 'digger', 'star:'], want: ['reels views'] },
      { when: ['likes'], want: ['custom comments'] },
      { when: ['followers'], want: ['instagram views'] },
      { when: ['views', 'reels', 'comments', 'shares', 'story'], want: ['instagram likes'] }
    ],
    tiktok: [
      { when: ['starter', 'pro:', 'digger', 'star:'], want: ['tiktok comments'] },
      { when: ['followers', 'views', 'shares'], want: ['tiktok likes'] },
      { when: ['likes'], want: ['tiktok views'] },
      { when: ['comments'], want: ['tiktok shares'] }
    ],
    facebook: [
      { when: ['starter', 'pro:', 'digger'], want: ['story views'] },
      { when: ['post likes', 'followers', 'page likes'], want: ['video views'] },
      { when: ['video views', 'story'], want: ['post likes'] }
    ],
    audiomack: [
      { when: ['plays', 'likes'], want: ['audiomack followers'] },
      { when: ['followers'], want: ['audiomack plays'] }
    ],
    tidal: [
      { when: ['plays', 'likes', 'listeners', 'placement'], want: ['tidal followers'] },
      { when: ['followers'], want: ['tidal plays'] }
    ],
    deezer: [
      { when: ['plays', 'likes'], want: ['deezer followers'] },
      { when: ['followers'], want: ['deezer plays'] }
    ],
    mixcloud: [
      { when: ['plays', 'mix'], want: ['mixcloud followers'] },
      { when: ['likes', 'reposts', 'followers'], want: ['mixcloud plays'] }
    ],
    twitch: [
      { when: ['views'], want: ['twitch followers'] },
      { when: ['followers'], want: ['video views'] }
    ],
    threads: [
      { when: ['likes', 'comments'], want: ['threads followers'] },
      { when: ['followers'], want: ['threads likes'] }
    ],
    x: [
      { when: ['followers', 'mix'], want: ['twitter) likes'] },
      { when: ['likes'], want: ['retweets'] },
      { when: ['retweets'], want: ['twitter) followers'] }
    ]
    /* apple, beatport, ra, traxsource, itunes, podcast, radio, blogs, packages, bandcamp,
       boomplay, discord — другого товару своєї платформи немає, одразу CROSS */
  };
  var CROSS = {
    beatport:   ['spotify', ['buy plays']],
    ra:         ['spotify', ['buy plays']],
    traxsource: ['beatport', ['daily push']],
    apple:      ['spotify', ['buy plays']],
    tidal:      ['apple', ['apple music plays']],
    deezer:     ['apple', ['apple music plays']],
    boomplay:   ['apple', ['apple music plays']],
    itunes:     ['apple', ['apple music plays']],
    twitch:     ['youtube', ['youtube views']],
    facebook:   ['instagram', ['instagram likes']],
    threads:    ['instagram', ['instagram likes']],
    x:          ['instagram', ['instagram likes']],
    discord:    ['instagram', ['instagram likes']],
    tiktok:     ['instagram', ['reels views']],
    mixcloud:   ['soundcloud', ['soundcloud plays']],
    bandcamp:   ['soundcloud', ['soundcloud plays']],
    audiomack:  ['spotify', ['buy plays']],
    podcast:    ['spotify', ['buy plays']],
    radio:      ['spotify', ['buy plays']],
    blogs:      ['spotify', ['buy plays']],
    packages:   ['spotify', ['monthly listeners']],
    spotify:    ['apple', ['apple music plays']],
    soundcloud: ['youtube', ['youtube views']],
    youtube:    ['instagram', ['instagram likes']],
    instagram:  ['youtube', ['youtube views']]
  };
  /* product_type → ключ платформи (пошук підрядка, порядок важливий: «apple» раніше за «itunes» тощо) */
  var TYPE_KEYS = [
    ['resident advisor', 'ra'], ['apple music', 'apple'], ['x (twitter)', 'x'], ['music blogs', 'blogs'],
    ['music promotion packages', 'packages'], ['music promotion guides', 'guides'],
    ['spotify', 'spotify'], ['soundcloud', 'soundcloud'], ['youtube', 'youtube'], ['instagram', 'instagram'],
    ['tiktok', 'tiktok'], ['facebook', 'facebook'], ['tidal', 'tidal'], ['deezer', 'deezer'],
    ['boomplay', 'boomplay'], ['twitch', 'twitch'], ['threads', 'threads'], ['mixcloud', 'mixcloud'],
    ['bandcamp', 'bandcamp'], ['audiomack', 'audiomack'], ['podcast', 'podcast'], ['radio', 'radio'],
    ['beatport', 'beatport'], ['traxsource', 'traxsource'], ['itunes', 'itunes'], ['discord', 'discord']
  ];
  /* ключ платформи → іконка з <template id="ap-reco-icons"> */
  var ICON_KEY = { tiktok: 'tiktok', youtube: 'youtube', instagram: 'instagram', facebook: 'facebook', spotify: 'spotify', soundcloud: 'soundcloud', mixcloud: 'soundcloud' };

  function platformOf(type) {
    var t = (type || '').toLowerCase();
    for (var i = 0; i < TYPE_KEYS.length; i++) if (t.indexOf(TYPE_KEYS[i][0]) !== -1) return TYPE_KEYS[i][1];
    return null;
  }
  function hasAny(title, words) {
    var t = (title || '').toLowerCase();
    for (var i = 0; i < words.length; i++) if (t.indexOf(words[i]) !== -1) return true;
    return false;
  }
  function money(cents) { return symbol + (cents / 100).toFixed(2); }

  /* каталог: /products.json (усі активні, включно з прихованими від Google), кеш 30 хв у sessionStorage */
  var CACHE_KEY = 'ap_cart_catalog_v1', CACHE_TTL = 30 * 60 * 1000;
  function loadCatalog() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.t && Date.now() - c.t < CACHE_TTL && c.items && c.items.length) return Promise.resolve(c.items);
    } catch (e) {}
    return fetch(ROOT + 'products.json?limit=250').then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var items = (d.products || []).map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          return v ? { id: p.id, title: p.title, vtitle: v.title === 'Default Title' ? '' : v.title, handle: p.handle, type: p.product_type || '', tags: p.tags || [], vid: v.id, price: Math.round(parseFloat(v.price) * 100) } : null;
        }).filter(Boolean);
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        return items;
      }).catch(function () { return []; });
  }
  /* Пакети («TikTok Pro: 10k Views + 500 Likes + 250 Followers», «Starter Mix»): не радимо
     послугу, яка вже є в пакеті. Кандидат відкидається, якщо його «вид» (фраза або її
     ключове слово) зустрічається в назві товару-якоря. Для одиночних послуг не застосовується. */
  var KIND_PHRASES = [
    ['story views', null], ['reels views', null], ['shorts views', null], ['live views', null],
    ['video views', 'views'], ['post likes', 'likes'], ['page likes', 'likes'], ['playlist likes', 'likes'],
    ['track likes', 'likes'], ['custom comments', 'comments'], ['monthly listeners', 'listeners'],
    ['playlist plays', 'plays'], ['retweets', null],
    ['views', null], ['likes', null], ['followers', null], ['comments', null], ['shares', null],
    ['plays', null], ['reposts', null], ['saves', null], ['subscribers', null], ['listeners', null], ['members', null]
  ];
  var anchorTitle = reco.getAttribute('data-product-title') || '';
  var anchorLower = anchorTitle.toLowerCase();
  var anchorIsBundle = anchorLower.indexOf('+') !== -1 || /\b(starter|pro|digger|star|mix|pack|package)\b/.test(anchorLower);
  function overlapsAnchor(title) {
    if (!anchorIsBundle) return false;
    var t = (title || '').toLowerCase();
    for (var i = 0; i < KIND_PHRASES.length; i++) {
      if (t.indexOf(KIND_PHRASES[i][0]) === -1) continue;
      if (anchorLower.indexOf(KIND_PHRASES[i][0]) !== -1) return true;
      if (KIND_PHRASES[i][1] && anchorLower.indexOf(KIND_PHRASES[i][1]) !== -1) return true;
      return false;
    }
    return false;
  }
  function usable(item) {
    return inCart.indexOf(String(item.id)) === -1 && platformOf(item.type) !== 'guides' && !overlapsAnchor(item.title);
  }
  /* товар платформи, у назві якого є одне зі слів; коротша назва = базовий товар, він і виграє */
  function pick(items, platform, words) {
    var list = items.filter(function (it) { return usable(it) && platformOf(it.type) === platform && hasAny(it.title, words); });
    list.sort(function (a, b) { return a.title.length - b.title.length; });
    return list[0] || null;
  }
  function pickPopular(items, platform) {
    var list = items.filter(function (it) { return usable(it) && platformOf(it.type) === platform && it.tags.indexOf('Popular') !== -1; });
    list.sort(function (a, b) { return a.price - b.price; });
    return list[0] || null;
  }
  /* Підпис у картці: назва варіанта (у ній є кількість — «500 TikTok Likes»). У Spotify-товарів
     платформи в назві немає — додаємо «SPTF» після числа («1000 SPTF Monthly Listeners»).
     SoundCloud лишаємо як є, без скорочень. Рішення Яни, 09.2026. */
  function label(p) {
    var t = p.vtitle || p.title, pl = platformOf(p.type);
    if (pl === 'spotify' && !/sptf|spotify/i.test(t)) t = /^\d[\d.,k]*\s/i.test(t) ? t.replace(/^(\d[\d.,k]*)\s/i, '$1 SPTF ') : 'SPTF ' + t;
    return t;
  }
  function iconFor(platform) {
    var tpl = document.getElementById('ap-reco-icons');
    var key = ICON_KEY[platform] || 'other';
    var node = tpl && tpl.content ? tpl.content.querySelector('[data-platform="' + key + '"]') : null;
    return node ? node.innerHTML : '';
  }
  function show(p) {
    if (!p || inCart.indexOf(String(p.id)) !== -1 || !p.vid) return false;
    document.getElementById('ap-reco-title').textContent = label(p);
    document.getElementById('ap-reco-price').textContent = '+' + money(p.price);
    document.getElementById('ap-reco-icon').innerHTML = iconFor(platformOf(p.type));
    var add = document.getElementById('ap-reco-add');
    add.onclick = function () {
      add.disabled = true;
      /* трекінг: прихована властивість рядка (_source) + атрибут замовлення (cross_sell) + подія GA4, якщо є gtag */
      var payload = { items: [{ id: p.vid, quantity: 1, properties: { _source: 'cart-reco', _anchor: reco.getAttribute('data-product-title') || '' } }] };
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) {
          /* fetch відхиляється лише на мережевій помилці: 422 (варіант недоступний, ліміт)
             приходить сюди як успіх. Без цієї перевірки атрибут cross_sell ставився на кошик,
             у якому товару з віджета немає. throw піде у наявний .catch — кнопка розблокується. */
          if (!r.ok) throw new Error('cart/add failed: ' + r.status);
          return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { cross_sell: p.title } }) });
        })
        .then(function () {
          try { if (window.gtag) window.gtag('event', 'add_to_cart', { currency: 'USD', value: p.price / 100, items: [{ item_id: String(p.id), item_name: p.title, item_list_name: 'cart_recommendation', price: p.price / 100, quantity: 1 }] }); } catch (e) {}
          window.location.reload();
        })
        .catch(function () { add.disabled = false; });
    };
    slot.hidden = false;
    try { if (window.gtag) window.gtag('event', 'view_item_list', { item_list_name: 'cart_recommendation', items: [{ item_id: String(p.id), item_name: p.title, price: p.price / 100 }] }); } catch (e) {}
    return true;
  }
  /* останній резерв — рекомендації Shopify (для товару з кошика) */
  function fromShopify(productId) {
    return fetch(ROOT + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var list = (d.products || []).filter(function (p) { return p.available && inCart.indexOf(String(p.id)) === -1 && platformOf(p.type) !== 'guides' && !overlapsAnchor(p.title); });
        var p = list[0]; if (!p) return null;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        return v ? { id: p.id, title: p.title, vtitle: v.title === 'Default Title' ? '' : v.title, type: p.type || '', vid: v.id, price: v.price } : null;
      }).catch(function () { return null; });
  }

  /* якір — останній доданий товар (cart.items.first) */
  var anchorPlatform = platformOf(reco.getAttribute('data-product-type')) || platformOf(anchorTitle);
  if (anchorPlatform === 'guides') { reco.hidden = true; return; }

  function choose(items) {
    var rules = SAME[anchorPlatform] || [], i, p;
    /* 1) своє правило; якщо його товар уже в кошику — наступні правила по черзі */
    var order = [];
    for (i = 0; i < rules.length; i++) if (hasAny(anchorTitle, rules[i].when)) { order.push(rules[i]); break; }
    for (i = 0; i < rules.length; i++) if (order.indexOf(rules[i]) === -1) order.push(rules[i]);
    for (i = 0; i < order.length; i++) { p = pick(items, anchorPlatform, order[i].want); if (p) return p; }
    /* 2) Popular своєї платформи — лише там, де є власна драбина (пакетам/Beatport/RA одразу CROSS) */
    if (rules.length) { p = pickPopular(items, anchorPlatform); if (p) return p; }
    /* 3–4) інша платформа */
    var cross = CROSS[anchorPlatform];
    if (cross) {
      p = pick(items, cross[0], cross[1]) || pickPopular(items, cross[0]);
      if (p) return p;
    }
    return null;
  }

  loadCatalog()
    .then(function (items) { return (items && items.length) ? choose(items) : null; })
    .then(function (p) { return p || fromShopify(reco.getAttribute('data-product-id')); })
    .then(function (p) { if (p) show(p); });
})();
